import React from 'react';
import AddTask from '../tasks/AddTask';
import Tasks from '../tasks/Tasks';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import '@animxyz/core';
import { XyzTransition } from '@animxyz/react';

const Layout = ({ uid }) => {
  if (!uid) return <Navigate to='/' replace />;
  
  return (
      <XyzTransition
        appear
        xyz='fade duration-20 appear delay-4'
      >
        <Container>
          <AddTask />
          <Tasks />
        </Container>
      </XyzTransition>
  );
};

const mapStateToProps = (state) => {
  const uid = state.firebase.auth.uid;
  return {
    uid: uid,
  };
};

export default connect(mapStateToProps)(Layout);
